import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { MDButton } from '../../../components/MDButton';
import { MDTypography } from '../../../components/MDTypography';

const useStyles = makeStyles((theme) => ({
  dialog: {
    '& .MuiDialog-paper': {
      minWidth: 400,
      maxWidth: 500,
      padding: theme.spacing(2),
    },
  },
  title: {
    fontWeight: 600,
    fontSize: '1.25rem',
    marginBottom: theme.spacing(2),
  },
  content: {
    paddingTop: 0,
    paddingBottom: theme.spacing(2),
  },
  actions: {
    padding: theme.spacing(2, 3),
    gap: theme.spacing(1),
  },
}));

interface ConfirmationDialogProps {
  open: boolean;
  title?: string;
  message?: string;
  confirmText?: string;
  cancelText?: string;
  onConfirm: () => void;
  onCancel: () => void;
  loading?: boolean;
}

export const ConfirmationDialog: React.FC<ConfirmationDialogProps> = ({
  open,
  title = 'Confirm Action',
  message = 'Are you sure you want to continue?',
  confirmText = 'OK',
  cancelText = 'Cancel',
  onConfirm,
  onCancel,
  loading = false,
}) => {
  const classes = useStyles();

  return (
    <Dialog
      open={open}
      onClose={onCancel}
      className={classes.dialog}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle className={classes.title}>
        <MDTypography variant="h6" fontWeight="medium">
          {title}
        </MDTypography>
      </DialogTitle>
      
      <DialogContent className={classes.content}>
        <MDTypography variant="body2" color="text">
          {message}
        </MDTypography>
      </DialogContent>

      <DialogActions className={classes.actions}>
        <MDButton
          variant="outlined"
          color="secondary"
          onClick={onCancel}
          disabled={loading}
        >
          {cancelText}
        </MDButton>
        <MDButton
          variant="gradient"
          color="info"
          onClick={onConfirm}
          disabled={loading}
        >
          {loading ? 'Processing...' : confirmText}
        </MDButton>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationDialog;
